import Link from 'next/link';
import { useIntl } from 'react-intl';
import { SwiperSlide } from 'swiper/react';

import { BlockProgram } from '@/components/BlockProgram';
import { SwiperBlock } from '@/components/carouselsBlocks/SwiperBlock';
import { useMediasPrograms } from '@/modules/medias/hooks/useMediasPrograms';
import { Breakpoints, Media } from '@/types';
import { convertDurationMin } from '@/utils';

export interface SearchEpisodesBlockProps {
  block: { items: Media[]; title?: string; UUID?: string };
  onClick?: (UUID) => void;
}

export const SearchMediasBlock = ({ block, onClick }: SearchEpisodesBlockProps) => {
  const { formatMessage } = useIntl();
  const { mediasProgramsData } = useMediasPrograms(block.items);

  const { title } = block;

  return (
    <div className="blocks">
      <h2 className="title">{title}</h2>
      <SwiperBlock
        slidesPerView={3.4}
        slidesPerGroup={3}
        spaceBetween={10}
        slidesOffsetAfter={20}
        slidesOffsetBefore={20}
        navigation={true}
        freeMode={true}
        className="block-swiper"
        breakpoints={{
          [Breakpoints.Small]: {
            slidesPerView: 4.4,
            slidesPerGroup: 4,
          },
          [Breakpoints.Medium]: {
            slidesPerView: 5.4,
            slidesPerGroup: 5,
          },
          [Breakpoints.Large]: {
            slidesPerView: 6.4,
            slidesPerGroup: 6,
          },
          [Breakpoints.ExtraLarge]: {
            slidesPerView: 7.6,
            slidesPerGroup: 6,
          },
        }}
      >
        {mediasProgramsData.map(({ media, program }) => (
          <SwiperSlide key={`search-block_${media.UUID}`}>
            <Link
              href={program.route}
              onClick={(UUID) => onClick(UUID)}
              aria-label={formatMessage(
                { id: 'catalogScreen.accessibility.program.link' },
                { programTitle: media.title }
              )}
              className="h-full flex flex-col justify-between"
            >
              <BlockProgram program={program} showTitle showKeyword />

              <p className="text-xs px-1 text-brand-neutral-300 leading-normal pb-2 hidden lg:block">
                {formatMessage(
                  {
                    id: `common.program.linear.default.description`,
                  },
                  {
                    episode: media.episode,
                    duration: convertDurationMin(media.duration),
                  }
                )}
              </p>
            </Link>
          </SwiperSlide>
        ))}
      </SwiperBlock>
    </div>
  );
};
